import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'
import {
  getDashboardOverview,
  getDashboardOrganisations,
  getDashboardSubscriptions
} from '../../redux/actions/dashboardActions'

import Dashboard from '../../components/dashboard'
import Loading from '../../components/loading'

class DashboardPage extends Component {
  organisationSearchTimer = null
  subscriptionsSearchTimer = null

  constructor(props) {
    super(props)
    this.state = {
      organisationsPage: 1,
      organisationsPageSize: 10,
      organisationsSearch: '',
      subscriptionsPage: 1,
      subscriptionsPageSize: 10,
      subscriptionsSearch: ''
    }
  }

  componentWillMount() {
    this.loadDashboardData()
  }

  componentWillUnmount() {
    if (this.organisationSearchTimer) {
      clearTimeout(this.organisationSearchTimer)
    }

    if (this.subscriptionsSearchTimer) {
      clearTimeout(this.subscriptionsSearchTimer)
    }
  }

  loadDashboardData = () => {
    const {
      organisationsPage,
      organisationsPageSize,
      organisationsSearch,
      subscriptionsPage,
      subscriptionsPageSize,
      subscriptionsSearch
    } = this.state
    this.props.getDashboardOverview()
    this.props.getDashboardOrganisations(organisationsPage, organisationsPageSize, organisationsSearch)
    this.props.getDashboardSubscriptions(subscriptionsPage, subscriptionsPageSize, subscriptionsSearch)
  }

  handleOrganisationPageChange = (pageNumber) => {
    this.setState({ organisationsPage: pageNumber })
    this.props.getDashboardOrganisations(pageNumber, this.state.organisationsPageSize, this.state.organisationsSearch)
  }

  handleSubscriptionsPageChange = (pageNumber) => {
    this.setState({ subscriptionsPage: pageNumber })
    this.props.getDashboardSubscriptions(pageNumber, this.state.subscriptionsPageSize, this.state.subscriptionsSearch)
  }

  handleOrganisationSearchChange = (value) => {
    this.setState({ organisationsSearch: value, organisationsPage: 1 })
    if (this.organisationSearchTimer) {
      clearTimeout(this.organisationSearchTimer)
    }

    this.organisationSearchTimer = setTimeout(() => {
      this.props.getDashboardOrganisations(1, this.state.organisationsPageSize, value)
    }, 500)
  }

  handleSubscriptionsSearchChange = (value) => {
    this.setState({ subscriptionsSearch: value, subscriptionsPage: 1 })
    if (this.subscriptionsSearchTimer) {
      clearTimeout(this.subscriptionsSearchTimer)
    }

    this.subscriptionsSearchTimer = setTimeout(() => {
      this.props.getDashboardSubscriptions(1, this.state.subscriptionsPageSize, value)
    }, 500)
  }

  handleOrganisationRowClick = (organisationId) => {
    history.push(`/organisation-detail/${organisationId}`)
  }

  handleSubscriptionRowClick = (subscriptionId) => {
    history.push(`/subscription/${subscriptionId}`)
  }

  handleTermsAcceptanceLogsClick = () => {
    history.push('/terms-acceptance-logs')
  }

  handleRefreshDashboard = () => {
    this.loadDashboardData()
  }

  render() {
    const { translate, dashboard, loading, activeLanguage } = this.props

    if (loading) {
      return <Loading />
    }

    return (
      <Dashboard
        translate={translate}
        activeLanguage={activeLanguage}
        dashboard={dashboard}
        onOrganisationRowClick={this.handleOrganisationRowClick}
        onSubscriptionRowClick={this.handleSubscriptionRowClick}
        onTermsAcceptanceLogsClick={this.handleTermsAcceptanceLogsClick}
        onRefreshDashboard={this.handleRefreshDashboard}
        onOrganisationPageChange={this.handleOrganisationPageChange}
        onSubscriptionsPageChange={this.handleSubscriptionsPageChange}
        onOrganisationSearchChange={this.handleOrganisationSearchChange}
        onSubscriptionsSearchChange={this.handleSubscriptionsSearchChange}
        organisationsPage={this.state.organisationsPage}
        organisationsSearch={this.state.organisationsSearch}
        subscriptionsPage={this.state.subscriptionsPage}
        subscriptionsSearch={this.state.subscriptionsSearch}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  dashboard: state.dashboardReducer,
  translate: getTranslate(state.localeReducer),
  activeLanguage: state.languageReducer.selectedLanguage,
  ...state
})

const mapDispatchToProps = {
  getDashboardOverview,
  getDashboardOrganisations,
  getDashboardSubscriptions
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DashboardPage)
